/**
 * Created by kennethmwangi on 24/04/2017.
 */
import { Injectable } from '@angular/core'
import { Http } from '@angular/http'
import {BaseService} from "./base-service";
import {Settings} from "../settings/base";


@Injectable()
export class VisitServiceService extends BaseService {


  constructor(private http: Http, private _settings: Settings) {

    super();
  }

  addService(visit_service){
    return this.http.post(this._settings.base_url+ "visit_service/",JSON.stringify(visit_service),this.createHeaders("Authorization"))
      .map(res => res.json());
  }

  getVisitServices(visit_id){
     return this.http.get(this._settings.base_url+ "visit_service/services/"+visit_id+"/", this.createHeaders("Authorization"))
      .map(res => res.json());
  }

   private getUrl(id) {
    return this._settings.base_url+ "visit_service/" + id+"/";

  }

}



// WEBPACK FOOTER //
// ./src/providers/visit-service-service.ts